module.exports = __webpack_public_path__ + "media/images/a4-291b3a798a45600e4c7f8a8b369a84bd.jpg";